// extracted by mini-css-extract-plugin
module.exports = {"right":"ArrowIcon_right__ANHSi","left":"ArrowIcon_left__0AV78","top":"ArrowIcon_top__tOna8","bottom":"ArrowIcon_bottom__262m_"};